import React, { useEffect, useRef, useState } from 'react';
import floorPlans from '@/components/Plans/floorPlans';
import { Loader, Message, Popover, Stack, Tooltip, useToaster, Whisper } from 'rsuite';
import { io, Manager } from 'socket.io-client';
import { format, isEqual, startOfDay } from 'date-fns';
import { useLocation } from 'react-router-dom';
import Joyride from 'react-joyride';
import { useTranslation } from 'react-i18next';
import parse from 'html-react-parser';
import ConfirmModal from '@/components/ConfirmModal';
import { deleteResourceReservation } from '@/services/operation.service';
import { useAppDispatch } from '@/config/hooks';

const credentials = btoa(`${process.env.REACT_APP_USERNAME}:${process.env.REACT_APP_PASSWORD}`);

const Floor = ({ floor, selectedDate, desks, setDesks, position, setPosition, scale }) => {
  const socketRef: any = useRef();

  const dispatch = useAppDispatch();
  const toaster = useToaster();

  const location = useLocation();
  const reservationData = location.state;

  const [FloorPlanComponent, setFloorPlanComponent] = useState<any>(null);
  const [loading, setLoading] = useState(true);
  const [loadingData, setLoadingData] = useState(false);
  const [steps, setSteps] = useState<any>([]);
  const [run, setRun] = useState(false);
  const [svgContent, setSvgContent] = useState(null);
  const containerRef = useRef(null);
  const svgWrapperRef = useRef(null);
  const [viewBox, setViewBox] = useState('0 0 1200 900');
  const [width, setWidth] = useState(1130);
  const [height, setHeight] = useState(900);

  const [dragging, setDragging] = useState(false);
  const [start, setStart] = useState({ x: 0, y: 0 });

  const [confirmModal, setConfirmModal] = useState<any>({
    open: false,
    title: '',
    subtitle: ''
  });

  const refAm = useRef(null);
  const refPm = useRef(null);

  // useEffect(() => {
  //   if (!floor) {
  //     console.error('Floor data is missing.');
  //     return;
  //   }

  //   const floorKey = `${floor?.building?.address}.${floor?.floor_num}`;

  //   const loadFloorPlan = floorPlans[floorKey];
  //   if (!loadFloorPlan) {
  //     console.error(`No floor plan found for key: ${floorKey}`);
  //     setLoading(false);
  //     return;
  //   }

  //   setLoading(true);
  //   loadFloorPlan()
  //     .then(FloorPlan => {
  //       setFloorPlanComponent(() => FloorPlan);
  //       setLoading(false);
  //     })
  //     .catch(err => {
  //       console.error(`Error loading floor plan for key: ${floorKey}`, err);
  //       setLoading(false);
  //     });
  // }, [floor]);

  useEffect(() => {
    if (!floor) {
      console.error('Floor data is missing.');
      return;
    }

    // const floorKey = `${floor?.building?.address}.${floor?.floor_num}`;

    if (!floor || !floor.floor_svg) {
      console.error('Floor or svg_plan is missing.');
      return;
    }

    const decodedSvg = floor.floor_svg;
    // if (decodedSvg) {
    //   setSvgContent(parse(decodedSvg));
    //   setLoading(false);
    // }

    if (decodedSvg) {
      let svgWidth = null;
      let svgHeight = null;
      let svgViewBox = null;
      const options = {
        replace: domNode => {
          if (domNode.type === 'tag' && domNode.name === 'svg' && !domNode.attribs?.id) {
            svgWidth = domNode.attribs?.width || null;
            svgHeight = domNode.attribs?.height || null;
            svgViewBox = domNode.attribs?.viewBox || null;
            domNode.attribs.id = 'floor-plan';
          }
          // if (domNode.type === 'tag' && domNode.name === 'svg') {
          //   domNode.attribs.id = 'floor-plan';
          //   delete domNode.attribs.width;
          //   delete domNode.attribs.height;
          //   domNode.attribs.style = 'width: 100%; height: 100%';
          // }
        }
      };

      const parsed = parse(decodedSvg, options);
      if (svgViewBox) setViewBox(svgViewBox);
      if (svgWidth) setWidth(svgWidth);
      if (svgHeight) setHeight(svgHeight);
      setSvgContent(parsed);

      setLoading(false);
    }

    // const loadFloorPlan = floorPlans[floorKey];
    // if (!loadFloorPlan) {
    //   console.error(`No floor plan found for key: ${floorKey}`);
    //   setLoading(false);
    //   return;
    // }

    // setLoading(true);
    // loadFloorPlan()
    //   .then(FloorPlan => {
    //     setFloorPlanComponent(() => FloorPlan);
    //     setLoading(false);
    //   })
    //   .catch(err => {
    //     console.error(`Error loading floor plan for key: ${floorKey}`, err);
    //     setLoading(false);
    //   });
  }, [floor]);

  //   useEffect(() => {
  //     socket = openSocket(process.env.REACT_APP_SOCKET_URL, {
  //       transports: ['websocket']
  //       // extraHeaders: {
  //       //   Authorization: `Basic ${credentials}`,
  //       // },
  //     });
  //   }, []);

  useEffect(() => {
    try {
      if (!socketRef.current) {
        //   socketRef.current = openSocket(process.env.REACT_APP_SOCKET_URL, {
        //     transports: ['websocket']
        //   });

        const manager = new Manager(process.env.REACT_APP_SOCKET_URL, {
          reconnectionDelayMax: 10000,
          extraHeaders: {
            authorization: `Basic ${credentials}`
          }
        });
        const newSocket = manager.socket('/', {
          // auth: {
          //   token: credentials
          // }
        });

        // works
        // const newSocket = io(process.env.REACT_APP_SOCKET_URL, {
        //   transports: ['websocket'],
        //   // query: {
        //   //   token
        //   // },
        //   extraHeaders: {
        //     authorization: `Basic ${credentials}`
        //   },
        //   withCredentials: true
        // });

        newSocket.on('connect', () => {
          console.log('Connected to socket server with auth!');
        });

        newSocket.on('connect_error', err => {
          console.error('Connection error:', err.message);
        });

        socketRef.current = newSocket;
      }
    } catch (e) {
      console.log('errooooooooor socket', e);
    }
  }, [credentials]);

  useEffect(() => {
    // if (socketRef.current && socketRef.current.connected) {
    const socket = socketRef.current;

    setLoadingData(true);

    socket.emit(`initial_data_F${floor?.floor_num}`, {
      id: floor?._id,
      date: format(selectedDate, 'yyyy-MM-dd')
    });
    socket.on(`get_data_F${floor?.floor_num}`, getData);
    socket.on(`change_data_F${floor?.floor_num}`, changeData);
    return () => {
      socket.off(`get_data_F${floor?.floor_num}`, getData);
      socket.off(`change_data_F${floor?.floor_num}`, changeData);
    };
    // }
  }, [selectedDate, floor, socketRef]);

  const getData = desks_data => {
    setDesks(desks_data);
    if (reservationData) {
      setSteps([
        {
          target: `#${reservationData.desk.name}-${reservationData.slot}`,
          content: 'The reservation has been located. Here is the position',
          placement: 'bottom'
        }
      ]);
      setRun(true);
    }
    setLoadingData(false);
  };

  const changeData = date => {
    if (isEqual(startOfDay(selectedDate), startOfDay(new Date(date)))) {
      socketRef.current.emit(`initial_data_F${floor?.floor_num}`, {
        id: floor?._id,
        date: format(selectedDate, 'yyyy-MM-dd')
      });
    }
  };
  const { t } = useTranslation();

  const getDeskColor = status => {
    switch (status) {
      case 'BLOCKED':
        return '#bac8d6';
      case 'BOOKED':
        return '#F3C318';
      case 'OCCUPIED':
        return '#FE3993';
      case 'AVAILABLE':
        return '#14e39a';
      default:
        return '#ccc';
    }
  };

  const getStatus = status => {
    switch (status) {
      case 'BLOCKED':
        return 'Blocked';
      case 'BOOKED':
        return 'Booked';
      case 'OCCUPIED':
        return 'Occupied';
      case 'AVAILABLE':
        return 'Available';
      default:
        return '';
    }
  };

  const handleDelete = async (resource, user, date, slot) => {
    try {
      setConfirmModal(prev => ({ ...prev, loading: true }));
      const data = {
        resource,
        user,
        date,
        slot
      };
      console.log('data', data);
      dispatch(deleteResourceReservation(data))
        .then(() => {
          toaster.push(
            <Message type="success" duration={5000} showIcon>
              {t('Deleted Successfully.')}
            </Message>,
            { placement: 'topCenter' }
          );
          setConfirmModal({
            open: false
          });
        })
        .catch(e => {
          toaster.push(
            <Message type="success" duration={5000} showIcon>
              {t(e)}
            </Message>,
            { placement: 'topCenter' }
          );
        });
    } catch (error) {}
  };

  return (
    <div>
      {loading && <Loader />}
      {/* {!FloorPlanComponent ? ( */}
      {!svgContent ? (
        <div>{t('Unable to load floor plan')}</div>
      ) : (
        <div className="relative h-full w-full">
          <Stack
            direction="row"
            spacing={20}
            justifyContent="center"
            alignItems="center"
            style={{ marginTop: 20 }}
          >
            <Stack direction="row" spacing={4} alignItems="center">
              <svg height="15" width="15">
                <circle cx="7.5" cy="7.5" r="5" fill="#FE3993" />
              </svg>
              <span style={{ color: '#32325d', fontSize: '15px' }}>{t('Occupied')}</span>
            </Stack>

            <Stack direction="row" spacing={4} alignItems="center">
              <svg height="15" width="15">
                <circle cx="7.5" cy="7.5" r="5" fill="#ff861c" />
              </svg>
              <span style={{ color: '#32325d', fontSize: '15px' }}>{t('Booked')}</span>
            </Stack>

            <Stack direction="row" spacing={4} alignItems="center">
              <svg height="15" width="15">
                <circle cx="7.5" cy="7.5" r="5" fill="#14e39a" />
              </svg>
              <span style={{ color: '#32325d', fontSize: '15px' }}>{t('Available')}</span>
            </Stack>

            <Stack direction="row" spacing={4} alignItems="center">
              <svg height="15" width="15">
                <circle cx="7.5" cy="7.5" r="5" fill="#a9a9ba" fillOpacity="0.4" />
              </svg>
              <span style={{ color: '#32325d', fontSize: '15px' }}>{t('Blocked')}</span>
            </Stack>

            <Stack direction="row" spacing={4} alignItems="center">
              <svg height="15" width="15">
                <path
                  fill="#ffffff"
                  stroke="#88889D"
                  d="M5 7.5c-.122-7.047 5.818-8.856 9.268-8.973l.221 8.76.221 8.759c-7.449.118-9.587-5.499-9.71-8.546z"
                />
              </svg>
              <span style={{ color: '#32325d', fontSize: '15px' }}>AM</span>
            </Stack>

            <Stack direction="row" spacing={4} alignItems="center">
              <svg height="15" width="15">
                <path
                  fill="#ffffff"
                  stroke="#88889D"
                  d="M5 7.5l-.221-8.76c7.449-.118 9.587 5.499 9.71 8.547.122 7.047-5.818 8.855-9.268 8.972l-.221-8.759z"
                />
              </svg>
              <span style={{ color: '#32325d', fontSize: '15px' }}>PM</span>
            </Stack>
          </Stack>

          <Stack
            direction="row"
            spacing={20}
            justifyContent="center"
            alignItems="center"
            style={{ marginTop: 20 }}
            id="floorPlanContainer"
          >
            <svg
              // className="plan"
              //   viewBox="0 0 900 1200"
              // width={1135}
              // height={907}
              id="floorPlanSVG"
              ref={svgWrapperRef}
              viewBox={viewBox}
              width={width}
              height={height}
              fill="none"
              //   xmlns="http://www.w3.org/2000/svg"
              stroke="transparent"
              strokeWidth={0}
              style={{
                // transform: `scale(${scale})`,
                // transformOrigin: 'top left',
                // transition: 'transform 0.3s ease-in-out',
                maxWidth: '100%',
                maxHeight: '100%',
                width: '100%',
                height: '100%',
                transform: `translate(${position?.x}px, ${position?.y}px) scale(${scale})`,
                // transformOrigin: 'center',
                transformOrigin: 'top left'
                // transition: dragging ? 'none' : 'transform 0.3s ease-in-out',
                // cursor: dragging ? 'grabbing' : 'grab'
              }}
              onMouseDown={e => {
                setDragging(true);
                setStart({ x: e.clientX - position.x, y: e.clientY - position.y });
              }}
              onMouseMove={e => {
                if (!dragging) return;
                setPosition({ x: e.clientX - start.x, y: e.clientY - start.y });
              }}
              onMouseUp={() => setDragging(false)}
              onMouseLeave={() => setDragging(false)}
              onTouchStart={e => {
                if (e.touches.length === 1) {
                  setDragging(true);
                  setStart({
                    x: e.touches[0].clientX - position.x,
                    y: e.touches[0].clientY - position.y
                  });
                }
              }}
              onTouchMove={e => {
                if (!dragging || e.touches.length !== 1) return;
                setPosition({
                  x: e.touches[0].clientX - start.x,
                  y: e.touches[0].clientY - start.y
                });
              }}
              onTouchEnd={() => setDragging(false)}
            >
              {svgContent}
              {/* <FloorPlanComponent /> */}

              {desks?.map((desk, index) => {
                const deskId = desk.Desk._id;

                return (
                  <g key={index}>
                    <Whisper
                      trigger="hover"
                      placement="left"
                      speaker={
                        <Popover style={{ width: 200, padding: 10 }}>
                          <Stack justifyContent="space-between">
                            <div>
                              <p style={{ fontSize: 13, margin: 0, fontWeight: 'bold' }}>
                                {desk?.Desk?.name}
                              </p>
                            </div>

                            {getStatus(desk.statusAM)}
                          </Stack>
                          {desk.UserAM
                            ? desk.UserAM?.firstname + ' ' + desk.UserAM?.lastname
                            : desk.GuestAM
                            ? desk.GuestAM
                            : ''}
                        </Popover>
                      }
                    >
                      <g>
                        <path
                          className="path"
                          fill={getDeskColor(desk.statusAM)}
                          d={desk.Desk.coordinations_web_am}
                          id={deskId + '-AM'}
                          onClick={() => {
                            if (desk.statusAM?.toLowerCase() === 'booked') {
                              setConfirmModal({
                                open: true,
                                title: 'Are you sure to remove this reservation ?',
                                subtitle: 'You cannot undo this operation',
                                onConfirm: () => {
                                  handleDelete(desk?.Desk?._id, desk?.UserAM?._id, desk.date, 'AM');
                                }
                              });
                            }
                          }}
                          // onClick={() => setOpenDesk(openDesk === deskId ? null : deskId)}
                          // style={{ cursor: isAccessible(desk) ? 'pointer' : 'not-allowed' }}
                          style={{ cursor: 'pointer' }}
                        />
                      </g>
                    </Whisper>

                    <Whisper
                      trigger="hover"
                      placement="left"
                      speaker={
                        <Popover style={{ width: 200, padding: 10 }}>
                          <Stack justifyContent="space-between">
                            <div>
                              <p style={{ fontSize: 13, margin: 0, fontWeight: 'bold' }}>
                                {desk?.Desk?.name}
                              </p>
                            </div>

                            {getStatus(desk.statusPM)}
                          </Stack>
                          {desk.UserPM
                            ? desk.UserPM?.firstname + ' ' + desk.UserPM?.lastname
                            : desk.GuestPM
                            ? desk.GuestPM
                            : ''}
                        </Popover>
                      }
                    >
                      <g>
                        <path
                          className="path"
                          fill={getDeskColor(desk.statusPM)}
                          d={desk.Desk.coordinations_web_pm}
                          id={deskId + '-PM'}
                          style={{ cursor: 'pointer' }}
                          onClick={() => {
                            if (desk.statusPM?.toLowerCase() === 'booked') {
                              setConfirmModal({
                                open: true,
                                title: 'Are you sure to remove this reservation ?',
                                subtitle: 'You cannot undo this operation',
                                onConfirm: () => {
                                  handleDelete(desk?.Desk?._id, desk?.UserPM?._id, desk.date, 'PM');
                                }
                              });
                            }
                          }}
                        />
                      </g>
                    </Whisper>
                  </g>
                );
              })}
            </svg>
          </Stack>
        </div>
      )}

      {confirmModal.open && (
        <ConfirmModal confirmDialog={confirmModal} setConfirmDialog={setConfirmModal} />
      )}

      <Joyride
        steps={steps}
        run={run}
        disableCloseOnEsc
        disableOverlayClose
        styles={{
          options: {
            zIndex: 10000,
            // arrowColor: '#007bff',
            // backgroundColor: 'rgb(6 220 218)'
            primaryColor: 'rgb(248 228 25)'
            // textColor: '#ffffff'
          }
        }}
        callback={data => {
          const { status, step } = data;
          if (step && step.target) {
            setTimeout(() => {
              document
                .querySelector('[data-test-id="button-primary"]')
                ?.style.setProperty('display', 'none', 'important');
            }, 100);
          }
        }}
      />
    </div>
  );
};

export default Floor;
